<div class="modal-header">
  <h4 class="modal-title" id="modal-task-title">Task List</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ngx-check-list
    *ngIf="purchaseOrder?.id"
    [checklist]="checklist"
    (checklistChange)="checklistChanged($event)"
    [purchaseOrderId]="purchaseOrder?.id"
    [purchaseOrder]="purchaseOrder"
    [allowToSaveChecklist]="true"
    [companyType]="'customer'"
  ></ngx-check-list>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary text-white" (click)="activeModal.close(checklist)">Finish</button>
</div>
